import Swiper, { Navigation } from 'swiper';

export default class SliderBase {
    /**
     * 
     * @param {string} className 
     * @param {SwiperOptions} config 
     * @param {boolean} hardOverwrite 
     * @returns 
     */
    static initAllWith(className, config, hardOverwrite = false) {
        className = (""+className).startsWith('.') ? className.substring(1) : className;
        const sliderBaseContainers = document.querySelectorAll(`.${className}.swiper`);
        if (sliderBaseContainers.length === 0) return;

        const defaultConfig = {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 10,
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 30
                }
            },
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
        }

        const mergedConfig = Object.assign({}, defaultConfig, config);

        sliderBaseContainers.forEach((sliderBaseContainer) => {
            new SliderBase(sliderBaseContainer, hardOverwrite ? config : mergedConfig);
        })
    }

    /**
     * 
     * @param {CSSSelector|HTMLElement} container 
     * @param {?SwiperOptions} config 
     */
    constructor(container, config) {
        this.swiper = new Swiper(container, config);
    }
}
